$(document).ready(() => {

    let cModalAutoSubmit = () => $('.cmodal form').trigger('submit');
    let cModalFileSelector = () => $('.cmodal input[type="file"]').trigger('click');
    let cModalGetContent = function () {
        let $modal = $(this);
        $.get($modal.data('url'), (res) => {
            $modal.find('.step-content').html(res.html);
            let stepNumber = $modal.find('.step-content form').data('step');
            let title = $modal.find('.step-content form').data('title');
            $modal.addClass('step-'+stepNumber);
            $modal.find('.title').text(title);
            $('.profile-progress').css('display', 'flex');
        });
    };
    let cModalKeyUp = function () {
        let $input = $(this);
        if($input.attr('id') !== 'digit4'){
            $input.parent().next().find('input').focus();
        }else{
            let code = $('#digit1').val()+$('#digit2').val()+$('#digit3').val()+$('#digit4').val();
            $('input[name="code"]').val(code)
        }
    };
    let cModalSubmit = function (event) {

        event.preventDefault();

        let $form = $(event.target);

        let onboardingStepSuccess = (res) => {
            $('.step-content').html(res.html);
            let title = $('.step-content form').data('title');
            let stepNumber = $('.step-content form').data('step');
            $('.step-content').closest('.modal-body').find('.title').text(title);
            $('.step-content').addClass('step-'+ stepNumber);
        };

        let onboardingStepError = (res) => $('.step-content').html(res.responseJSON.html);

        ajaxSubmitForm($form, onboardingStepSuccess, onboardingStepError);

    };

    $('#userOnboardingModal')
        .on('click', '.btn-upload', cModalFileSelector)
        .on('change', 'input[type="file"]', cModalAutoSubmit)
        .on('keyup', '.verification-code input', cModalKeyUp)
        .on('submit', 'form', cModalSubmit)
        .on('show.bs.modal', cModalGetContent)
        .on('hide.bs.modal', () => {
            $('.profile-progress').hide();
        });

});
